import {  DatabaseKey } from "../../../../repository/IDataStore";
import { IOrganisation, IAccessCode, IEmailHost, ILoginCode } from "../../../../model/ModelTypes";
import { Observable, Observer } from "rxjs";
import { flatMap, map } from "rxjs/operators";
import { BaseAdminOperations } from "../../BaseAdminOperations";
import { isNullOrUndefined } from "util";
import _ = require("lodash");
/**
 * Implements business logic for Operations avialable for access managements.
 */
export class AccessManagementOperations extends BaseAdminOperations {
    // tslint:disable-next-line:no-empty
    onInitializationComplete() {
    }
    observeOrganisationChanges(): Observable<IOrganisation> {
        return this.dataStore.getDocuments<Observable<IOrganisation>>(DatabaseKey.organisation)
        .pipe(
            flatMap(item => item),
            map( item => {
                this.organisation = item;
                return item;
            })
        );
        
    }

    getAccessCodes(): IAccessCode[] {
        return this.organisation.access_codes;
    }
    getEmailHosts(): IEmailHost[] {
        return this.organisation.email_hosts;
    }
    addItem(accessCodeRoleId?: string, emailHost?: {role_id: string, email_host: string}, loginCodeRoleId?: string): 
    Observable<IOrganisation> {
        return Observable.create(
            async (observer: Observer<IOrganisation>) => {
                let request
                : {access_code?: string , login_code?: string, email_host?: {role_id: string, email_host: string}} = {};
                if (!isNullOrUndefined(accessCodeRoleId)) {
                    request.access_code = accessCodeRoleId;
                }
                if (!isNullOrUndefined(emailHost)) {
                    request.email_host = emailHost;
                }
                if (!isNullOrUndefined(loginCodeRoleId)) {
                    request.login_code = loginCodeRoleId;
                }
                try {
                    let response = await this.adminApi
                    .getAuthenticatedHttpClient()
                    .getInstance()
                    .post(
                        `${this.config.apiBaseUrl}/api/organisations/${this.organisationCode.toLowerCase()}/access`,
                        request
                    );                
                    if (response.status === 200) {
                        type ResponseType = {
                            accessCode: IAccessCode,
                            emailHost: IEmailHost,
                            loginCode: ILoginCode
                        };
                        let responseData = <ResponseType> response.data;
                        if (!isNullOrUndefined(responseData)) {
                            if (!isNullOrUndefined(responseData.accessCode)) {
                                if (isNullOrUndefined(this.organisation.access_codes)) {
                                    this.organisation.access_codes = [];
                                }
                                let accessCodeIndex =
                                    this.organisation.access_codes.findIndex(
                                        item => item.role_id === responseData.accessCode.role_id
                                    );
                                if (accessCodeIndex > -1) {
                                    this.organisation.access_codes.splice(accessCodeIndex, 1);
                                }
                                this.organisation.access_codes.push(responseData.accessCode);
                            }
                            if (!isNullOrUndefined(responseData.emailHost)) {
                                if (isNullOrUndefined(this.organisation.email_hosts)) {
                                    this.organisation.email_hosts = [];
                                }
                                this.organisation.email_hosts.push(responseData.emailHost);
                            }
                            if (!isNullOrUndefined(responseData.loginCode)) {
                                if (isNullOrUndefined(this.organisation.loginCodes)) {
                                    this.organisation.loginCodes = [];
                                }
                                let existingCodesIndex = this.organisation.loginCodes.findIndex(
                                    item => item.roleId === responseData.loginCode.roleId);
                                if (existingCodesIndex > -1) {
                                    this.organisation.loginCodes.splice(existingCodesIndex, 1);
                                }
                                this.organisation.loginCodes.push(responseData.loginCode);
                            }
                            this.dataStore.insertDocument<IOrganisation>(this.organisation, DatabaseKey.organisation)
                            .first()
                            .subscribe(
                                result => {
                                    observer.next(this.organisation);
                                },
                                error => {
                                    this.reportError(error);
                                    observer.error(error);
                                }
                            );
                        } else {
                            observer.error(new Error(" Unable to add item "));
                            this.reportError(response.data);
                        }
                    }
                } catch (error) {
                    this.reportError(error);
                    observer.error(error);
                }

            }
        );
        
    }
    deleteItem(accessCodeRoleId?: string, emailHost?: {role_id: string, email_host: string}, loginCodeRoleId?: string):
    Observable<IOrganisation> {
        return Observable.create(
            async (observer: Observer<IOrganisation>) => {
                let request
                : {access_code?: string , login_code?: string, email_host?: {role_id: string, email_host: string}} = {};
                if (!isNullOrUndefined(accessCodeRoleId)) {
                    request.access_code = accessCodeRoleId;
                }
                if (!isNullOrUndefined(emailHost)) {
                    request.email_host = emailHost;
                }
                if (!isNullOrUndefined(loginCodeRoleId)) {
                    request.login_code = loginCodeRoleId;
                }
                try {
                    let response = await this
                    .adminApi
                    .getAuthenticatedHttpClient()
                    .getInstance()
                    .delete(
                        `${this.config.apiBaseUrl}/api/organisations/${this.organisationCode.toLowerCase()}/access`,
                        {
                            data: request
                        }
                    );
                    if (response.status === 200) {
                        type ResponseType = {
                            accessCode: IAccessCode,
                            emailHost: IEmailHost,
                            loginCode: ILoginCode
                        };
                        let responseData = <ResponseType> response.data;
                        if (!isNullOrUndefined(responseData)) {
                            if (!isNullOrUndefined(responseData.accessCode)) {
                                if (!isNullOrUndefined(this.organisation.access_codes)) {
                                    let accessCodeIndex = 
                                    this.organisation.access_codes.findIndex(
                                        item => _.isEqual(item, responseData.accessCode)
                                    );
                                    if (accessCodeIndex > -1) {
                                        this.organisation.access_codes.splice(accessCodeIndex, 1);
                                    }
                                }
                            }
                            if (!isNullOrUndefined(responseData.emailHost)) {
                                if (!isNullOrUndefined(this.organisation.email_hosts)) {
                                    let emailHostIndex = 
                                    this.organisation.email_hosts.findIndex(
                                        item =>
                                        _.isEqual(item, responseData.emailHost)
                                    );
                                    if (emailHostIndex > -1) {
                                        this.organisation.email_hosts.splice(emailHostIndex, 1);
                                    }
                                }
                            }
                            if (!isNullOrUndefined(responseData.loginCode)) {
                                if (!isNullOrUndefined(this.organisation.loginCodes)) {
                                    let itemIndex = this.organisation.loginCodes.findIndex(
                                        item => _.isEqual(item, responseData.loginCode)
                                    );
                                    if (itemIndex > -1) {
                                        this.organisation.loginCodes.splice(itemIndex, 1);
                                    }
                                }
                            }
                            this.dataStore.insertDocument<IOrganisation>(this.organisation, DatabaseKey.organisation)
                            .first()
                            .subscribe(
                                result => {
                                    observer.next(this.organisation);
                                },
                                error => {
                                    this.reportError(error);
                                    observer.error(error);
                                }
                            );
                        } else {
                            observer.error(new Error(" Unable to add item "));
                            this.reportError(response.data);
                        }
                    } else {
                        throw new Error("Unable to perfrom operation");
                    }
                } catch (error) {
                    observer.error(error);
                    this.reportError(error);
                }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/utility/admin/OrganisationOperations/AccessManagementOperations/AccessManagementOperations.ts